import axios from '@/utils/axios';

// Types

export interface SettingsResponseModel {
	payment: {
		enablePayment: boolean,
		enableAccountsConsultation: boolean,
	};
	booking: {
		enableBooking: boolean,
		enableUnbooking: boolean,
	};
	bookingShop: {
		enable: boolean
	};
	bookingResources: {
		enable: boolean
	};
	general: {
		applicationTitle: string,
		enableActivateAccount: boolean,
		enableForgotPassword: boolean
	};
}

export enum SettingsCategories {
	FEATURE = 1,
	ADVANCED_PARAMETER = 2,
	PARAMETER = 3,
	CUSTOMIZATION = 4
}


// API
export default {
	async getClientSettings(): Promise<SettingsResponseModel> {
		return (await axios().get(`/settings/client`)).data;
	},

	async getAllSettings(category: SettingsCategories): Promise<any> {
		return (await axios().get(`/settings/?category=${category}`)).data;
	},

	async getSyncSettings(): Promise<any> {
		return (await axios().get(`/settings/sync`)).data;
	},

	async saveAllSettings(payload: any): Promise<any> {
		return (await axios().post(`/settings/`, payload)).data;
	},

	async sendTestEmail(address: string): Promise<any> {
		return (await axios().post(`/settings/test_email/?addressToSendTo=${address}`)).data;
	},
};
